$(function () {
    var dropZoneId = "drop-zone";
    var buttonId = dropZoneId;
    var mouseOverClass = "mouse-over";

    var dropZone = $("#" + dropZoneId);

    if(dropZone.length === 0) {
      return;
    }

    var ooleft = dropZone.offset().left;
    var ooright = dropZone.outerWidth() + ooleft;
    var ootop = dropZone.offset().top;
    var oobottom = dropZone.outerHeight() + ootop;
    var inputFile = dropZone.find("input");
    document.getElementById(dropZoneId).addEventListener("dragover", function (e) {
        e.preventDefault();
        e.stopPropagation();
        dropZone.addClass(mouseOverClass);
        var x = e.pageX;
        var y = e.pageY;

        if (!(x < ooleft || x > ooright || y < ootop || y > oobottom)) {
            inputFile.offset({ top: y - 15, left: x - 100 });
        } else {
            inputFile.offset({ top: -400, left: -400 });
        }

    }, true);

    if (buttonId != "") {
        var clickZone = $("#" + buttonId);

        var oleft = clickZone.offset().left;
        var oright = clickZone.outerWidth() + oleft;
        var otop = clickZone.offset().top;
        var obottom = clickZone.outerHeight() + otop;

        $("#" + buttonId).mousemove(function (e) {
            var x = e.pageX;
            var y = e.pageY;
            if (!(x < oleft || x > oright || y < otop || y > obottom)) {
                inputFile.offset({ top: y - 15, left: x - 160 });
            } else {
                inputFile.offset({ top: -400, left: -400 });
            }
        });
    }



    $(document).on('change', 'input[type=file]' , function(){
	    $('#appURL').val('').prop('disabled', false);
        var filename = $('input[type=file]').val().split('\\').pop();
        if (filename != '') {
	        $("#" + dropZoneId + " span.droptext").html('<i class="fa fa-cloud-upload"></i> <span>' + filename + '</span>');
	        $('.removeFile').addClass('show');
	        $('.removeFile').addClass('show');
		    $('#appURL').val('').prop('disabled', true).parent().fadeTo('fast', '.25');;
	        $("#" + dropZoneId).addClass(mouseOverClass);
        } else {
	        $("#" + dropZoneId + " span.droptext").html('<i class="fa fa-cloud-upload"></i>...or drop an <span>.ipa</span> or <span>.apk</span> file here to upload.');
	        $('.removeFile').removeClass('show');
		    $('#appURL').prop('disabled', false).parent().fadeTo('fast', '1');;
        $("#" + dropZoneId).removeClass(mouseOverClass);
        }
	});


	$('.removeFile').on('click', function(e) {
		e.stopPropagation();
		$('input[type=file]').val('');
	        $('.removeFile').removeClass('show');
        $("#" + dropZoneId).removeClass(mouseOverClass);
	    $('#appURL').prop('disabled', false).parent().fadeTo('fast', '1');
        $("#" + dropZoneId + " span.droptext").html('<i class="fa fa-cloud-upload"></i>...or drop an <span>.ipa</span> or <span>.apk</span> file here to upload.');
		return false;
	});


})
